import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { useScopedAppFlagStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { Chip, Text, Truncated } from '@frontend/design-system';

type PhoneOptionProps = {
  defaultSms?: boolean;
  displayName?: string;
  isActive: boolean;
  phoneNumber: string;
  defaultAi?: boolean;
};

export const OldPhoneOption = ({ defaultSms, displayName, isActive, phoneNumber, defaultAi }: PhoneOptionProps) => {
  const formattedPhone = formatPhoneNumber(phoneNumber, true);
  const { t } = useTranslation('inbox');
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const inboxFusionEnabled = getFeatureFlagValue('nwx:inbox-fusion');

  if (displayName) {
    return (
      <div css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, width: '100%' }}>
        <div css={{ display: 'block', width: '100%', minWidth: 0 }}>
          <div css={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Truncated
              css={{
                fontWeight: isActive ? 'bold' : 'normal',
                textAlign: 'left',
                maxWidth: `calc(100% - ${theme.spacing(3)})`,
                width: 'fit-content',
              }}
              as={Text}
            >
              {displayName}
            </Truncated>
            {defaultSms && (
              <Chip variant='primaryDark' tooltipLabel={t('Default SMS Number')} css={{ padding: 4 }}>
                <Icon name='location-default' height={16} width={16} css={{ minWidth: theme.spacing(2) }} />
              </Chip>
            )}
            {defaultAi && inboxFusionEnabled && <Icon name='aiweave-assistant' size={16} />}
          </div>
          <Text textAlign='left'>{formattedPhone}</Text>
        </div>
      </div>
    );
  }

  return formattedPhone;
};
